const E = (typeof window !== "undefined" && window.__ENV) || {};

export const RUNTIME_ENV = {
  VUE_APP_NODE_ENV: E.VUE_APP_NODE_ENV || process.env.VUE_APP_NODE_ENV,
  VUE_APP_BASE_URL: E.VUE_APP_BASE_URL || process.env.VUE_APP_BASE_URL,
  VUE_APP_MAIN_URL: E.VUE_APP_MAIN_URL || process.env.VUE_APP_MAIN_URL,
  VUE_APP_API_URL: E.VUE_APP_API_URL || process.env.VUE_APP_API_URL,
  VUE_APP_FILE_URL: E.VUE_APP_FILE_URL || process.env.VUE_APP_FILE_URL,
  VUE_APP_TITLE: E.VUE_APP_TITLE || process.env.VUE_APP_TITLE,
  VUE_APP_TITLE_FA: E.VUE_APP_TITLE_FA || process.env.VUE_APP_TITLE_FA,
  VUE_APP_VERSION: E.VUE_APP_VERSION || process.env.VUE_APP_VERSION,
};
